import { cn } from "@/lib/utils";

const MenuIcon = ({ className }: { className?: string }) => (
  <svg
    viewBox="0 0 12 10"
    fill="none"
    aria-hidden
    className={cn("h-s w-s", className)}
  >
    <path
      d="M0 1h12M0 5h12M0 9h12"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export default MenuIcon;
